import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import AnimatedLogo from '@/components/AnimatedLogo';
import { AnimatedBackground } from '@/components/AnimatedBackground';

export function Hero() {
  return (
    <section className="relative py-32 flex items-center justify-center overflow-hidden bg-gradient-to-br from-background via-card to-background">
      <AnimatedBackground opacity={0.2} nodeCount={25} />
      
      <div className="container relative z-10 mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <div className="mb-8 flex justify-center">
            <AnimatedLogo size={180} showText={true} />
          </div>

          <p className="mb-8 text-xl text-muted-foreground md:text-2xl max-w-3xl mx-auto">
            DebtNet unifies CRM, valuation, analytics, and exchange — turning data into actionable intelligence.
          </p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link to="/auth">
              <Button size="lg" className="group">
                Get Started Free
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
              </Button>
            </Link>
            <Button 
              size="lg" 
              variant="outline" 
              className="group"
              onClick={() => {
                document.getElementById('seller-registration')?.scrollIntoView({ 
                  behavior: 'smooth',
                  block: 'start'
                });
              }}
            >
              Sell your Portfolio
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
